import "./tarifsDefault.css";
import TarifsTextTitle from "./components/tarifsTextTitle";
import TarifsTextContent from "./components/tarifsTextContent";
import TarifsTextContrat from "./components/tarifsTextContrat";

function TarifsContract() {
  const descriptionList = [
    "Un parc informatique bien entretenu, c’est moins de pannes, plus de productivité et des coûts maîtrisés.",
    "Avec ces formules, nous vous proposons un accompagnement flexible selon vos besoins, que ce soit pour des interventions ponctuelles ou un suivi régulier de vos équipements.",
    "Déplacement, diagnostic et prestation inclus dans chaque intervention.",
    "📌 Pourquoi opter pour un contrat de maintenance ?",
    "Prévenir plutôt que guérir : Moins de pannes et d’arrêts imprévus.",
    "Réduction des coûts : Une maintenance régulière coûte moins cher que des réparations d’urgence.",
    "Tranquillité d’esprit : Vous avez un expert disponible rapidement en cas de problème.",
  ];
  const forfait = [
    "✅ 5 interventions à utiliser quand vous le souhaitez.",
    "✅ Tout compris sauf pièce : Déplacement, diagnostic et intervention.",
    "✅ Souplesse : Vous utilisez les interventions selon vos besoins, sans limite de temps.",
    "💰 Tarif : 450€, payable dès la première intervention (soit 90€ par intervention TTC).",
  ];

  const contratSimple = [
    "✅ Une visite mensuelle à date convenue.",
    "✅ Vérification des installations et de leur bon fonctionnement.",
    "✅ Entretien préventif : Vérifications de l'état du système informatique, nettoyage, mises à jour, corrections mineures.",
    "💰 Tarif : 80€/mois, sans frais cachés.",
  ];

  const contratPlus = [
    "✅ Une visite mensuelle avec entretien préventif (comme le contrat classique).",
    "✅ 1 intervention d’urgence par mois incluse en cas de problème critique.",
    "✅ Interventions supplémentaires à tarif réduit : 80€ par intervention supplémentaire dans le mois.",
    "💰 Tarif : 120€/mois, pour une tranquillité totale.",
  ];
  return (
    <div className="tarifs-text-main-contenair">
      <TarifsTextTitle title="CONTRATS DE MAINTENANCE" minimal={true} />
      <div className="tarifs-text-main">
        <div className="tarifs-text-colA">
          <TarifsTextContent content={descriptionList} />
        </div>
        <div className="tarifs-text-colB">
          <TarifsTextContrat
            titre="📌 Forfait 5 interventions - 450€"
            list={forfait}
          />
        </div>
      </div>
      <div className="tarifs-text-main">
        <div className="tarifs-text-colA">
          <TarifsTextContrat
            titre="📌 Contrat de maintenance mensuel – 80€/mois"
            content={descriptionList}
            h="100%"
            list={contratSimple}
          />
        </div>
        <div className="tarifs-text-colB">
          <TarifsTextContrat
            list={contratPlus}
            titre="📌 Contrat de maintenance Plus – 120€/mois"
          />
        </div>
      </div>
    </div>
  );
}

export default TarifsContract;
